import axios from 'axios'
import store from '@/store/index'

const http = axios.create({
  baseURL: `${process.env.VUE_APP_BASEURL || 'http://localhost:8000/api/'}`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

function handlingError(error) {
  try {
    // const info = i18n.t('services.networkError')
    const info = 'Erro de conexão com o servidor.'
    let response,
      message = null

    if (error.code == 'ERR_NETWORK') response = info
    else if (error.response) response = error.response
    else if (error.message) response = error.message
    else response = error

    if (response && response.data && response.data != undefined) {
      if (response.status == 422) {
        // message = i18n.t('login.corrigir') + '<br>'
        message = 'Corrigir login'
        Object.keys(response.data.error).forEach((key) => {
          message += response.data.error[key] + '<br>'
        })
      } else {
        if (response.data.error) {
          if (response.data.error.message)
            message =
              response.data.error.error + ' ' + response.data.error.message
          else message = response.data.error
        } else {
          message =
            response.status + ' ' + response.statusText + '<br>' + error404()
        }
      }
    } else {
      message =
        response == 'Sessão expirada!'
          ? i18n.t('services.sessionExpired')
          : info
    }
    return Promise.reject(message)
  } catch (error) {
    console.error(error)
  }
}

http.interceptors.request.use(async function (config) {
  if (store.state.authModule.authUser) {
    const token = `Bearer ${store.state.authModule.authUser.access_token || ''}`
    config.headers.Authorization = token
  }

  config.headers.filial =
    store.state.companyListModule?.companyList?.FILIAL ?? 1

  return config
})

http.interceptors.response.use(
  (response) => {
    return response
  },
  async function (error) {
    const originalRequest = (await error) && error.config ? error.config : null
    const errorStatus = error && error.response ? error.response.status : null
    const errorText = error && error.response ? error.response.statusText : null
    const urlLogout =
      error && error.config ? error.config.baseURL + 'auth/logout' : ''
    /*
     * Quando a requisição tem status 401 e statusText,
     * será gerado uma nova requisição para gerar um novo token automaticamente
     */

    // if (errorStatus === 401 && errorText === 'Token is Expired') {
    //   const authPropName = store.state.authModule.storageAuthProperty
    //   const access_token = await refreshAccessToken()

    //   let user = ''
    //   user = JSON.parse(localStorage.getItem(authPropName))
    //   if (user && user != '') {
    //     user.access_token = access_token.data.token
    //     localStorage.setItem(authPropName, JSON.stringify(user))
    //   }

    //   await store.dispatch('authModule/updateAuthUser', user)

    //   originalRequest.headers.Authorization =
    //     'Bearer ' + access_token.data.token
    //   return axios(originalRequest)
    //   /*
    //    * Quando expirar o tempo de realizar o refresh automático do token,
    //    * será solicitado o relogin para o usuário
    //    */
    // } else
    if (errorStatus === 401) {
      await store.dispatch('authModule/clearAuthUser')
      await store.dispatch('authModule/loginUser')
      const { access_token } = store.state.authModule.authUser

      originalRequest.headers.Authorization = 'Bearer ' + access_token

      return axios(originalRequest)
    }

    return handlingError(error)
  }
)

async function refreshAccessToken() {
  return await http.post('/mbcommerce/auth/refresh')
}

function error404() {
  return 'Ooops... nada por aqui'
}

export default http
